const state = {
  navAwards: [
    {
      title: 'judges',
      dec: '2019',
      active: false
    },
    {
      title: 'rules',
      dec: 'adman',
      active: true
    },
    {
      title: 'categories',
      dec: 'adman',
      active: false
    }
  ]
}

const mutations = {
  AWARDS (state, title) {
    state.navAwards.forEach(nav => {
      nav.active = false

      if (nav.title === title) {
        nav.active = true
      }
    })
  }
}

const actions = {
  awards ({ commit }, title) {
    commit('AWARDS', title)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
